import React, { FC, memo, ReactNode } from 'react';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';
import FnImageWithReviewNative from '../../../../elements/FnImageWithReviewNative';
import { H2, SpanCounter, FontAwesomeIconStyled, SpanLabel, SpanValue, SpanSecondLine, SpanAction } from './styles';

type TProps = {
  text: string;
  count?: string;
  icon?: ReactNode;
  imageExistsUri?: string;
  secondLineLabel?: string;
  secondLineValue?: string | JSX.Element;
  actionBtn?: ReactNode;
};

const FnTitleModal: FC<TProps> = ({
  text,
  count = '',
  icon = null,
  imageExistsUri = '',
  secondLineLabel = '',
  secondLineValue = '',
  actionBtn = null
}) => {
  const hasSecondLineText = secondLineLabel || secondLineValue;

  return (
    <>
      {imageExistsUri && <FnImageWithReviewNative image={imageExistsUri} className="modal-title" />}
      <div>
        <H2>
          {icon && <FontAwesomeIconStyled icon={faExclamationTriangle} />}
          {text}
          {count && <SpanCounter>{count}</SpanCounter>}
        </H2>
        {(hasSecondLineText || actionBtn) && (
          <SpanSecondLine>
            {secondLineLabel && <SpanLabel>{secondLineLabel}</SpanLabel>}
            {secondLineValue && <SpanValue>{secondLineValue}</SpanValue>}
            <SpanAction>{actionBtn}</SpanAction>
          </SpanSecondLine>
        )}
      </div>
    </>
  );
};

export default memo(FnTitleModal);
